import { PersistedState } from 'runed';
import type { Period } from '~/types';

export const leaderboardPeriod = new PersistedState<Period>('classic-leaderboard', 'week');
